import React from 'react'
import classNames from 'classnames'
import './GridBlock.scss'

const GridBlock = ({ block, Block }) => {
  const layoutSettings = block.LayoutSettings || {}
  const mobileStackClass = layoutSettings.MobileStack ? 'mobile-stack' : ''
  const mobileReverseClass = layoutSettings.MobileReverse ? 'mobile-reverse' : ''

  // Parse the CSS styles from layoutSettings
  const gridStyle = {}
  if (layoutSettings.GridTemplateFr) {
    // Use the fr-based template provided by backend (works properly with gap)
    gridStyle.gridTemplateColumns = layoutSettings.GridTemplateFr
    gridStyle.display = 'grid'
  } else if (layoutSettings.CssStyles) {
    // Fallback: parse from CssStyles if GridTemplateFr is not available
    const styleString = layoutSettings.CssStyles
    const gridTemplateMatch = styleString.match(/grid-template-columns:\s*([^;]+)/)
    if (gridTemplateMatch) {
      gridStyle.gridTemplateColumns = gridTemplateMatch[1].trim()
      gridStyle.display = 'grid'
    }
  }

  // Convert PascalCase to kebab-case for CSS class (e.g., TwoColumn -> twocolumn)
  const blockTypeClass = block.BlockType.toLowerCase()

  return (
    <div
      className={classNames('block', `block-${blockTypeClass}`, mobileStackClass, mobileReverseClass)}
      style={gridStyle}
    >
      {block.Heading && <h2 className="grid-heading">{block.Heading}</h2>}
      {block.ChildBlocks && block.ChildBlocks.length > 0 && (
        <>
          {block.ChildBlocks
            .sort((a, b) => a.SortOrder - b.SortOrder)
            .map((child, index) => (
              <div key={child.Id || index} className="grid-item">
                <Block block={child} />
              </div>
            ))}
        </>
      )}
    </div>
  )
}

export default GridBlock
